/*
  Carrousel de l'accroche d'accueil (sections/hero-split.liquid).
  Sans JavaScript, les cartes défilent déjà au doigt par scroll-snap ; ce
  script ajoute les points de navigation, le défilement automatique et la
  pause au survol, au focus ou au toucher. Respecte prefers-reduced-motion.
*/
class HeroCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.slides = this.track ? Array.from(this.track.children) : [];
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    if (this.slides.length < 2) return;

    this.index = 0;
    this.interval = Math.max(2, parseInt(this.dataset.interval || '5', 10)) * 1000;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
    ['pointerenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, () => this.pause(), { passive: true }));
    ['pointerleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.resume()));
    document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.resume()));

    this.setActive(0);
    if (this.dataset.autoplay === 'true' && !this.reduced) this.resume();
  }

  disconnectedCallback() {
    this.pause();
  }

  go(i, manual) {
    this.index = (i + this.slides.length) % this.slides.length;
    const slide = this.slides[this.index];
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
    this.setActive(this.index);
    if (manual) {
      this.pause();
      this.resume();
    }
  }

  onScroll() {
    window.clearTimeout(this.scrollTimer);
    this.scrollTimer = window.setTimeout(() => {
      const left = this.track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      this.index = best;
      this.setActive(best);
    }, 80);
  }

  setActive(i) {
    this.dots.forEach((dot, j) => {
      dot.setAttribute('aria-current', j === i ? 'true' : 'false');
    });
  }

  pause() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  resume() {
    if (this.dataset.autoplay !== 'true' || this.reduced || this.timer) return;
    this.timer = window.setInterval(() => this.go(this.index + 1, false), this.interval);
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel);
}
